var _circle, _circle2, _circle3, _path, _circle4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 95,
    viewBox: "0 0 82 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#F58120"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "url(#paint0_linear)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.6846,
    cy: 32.0919,
    r: 12.7217,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6841 48.2061C21.29 48.2061 8 61.4961 8 77.8901H67.3681C67.3681 61.4961 54.0781 48.2061 37.6841 48.2061Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 76,
    r: 19,
    fill: "#FFB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80.2167L58.2951 86.2261C58.1311 86.7875 57.1803 87.2002 56.0656 87.2002H56V80.2497L57.3115 80.2002H60V80.2167Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.248 75.9257C69.248 77.6797 67.8229 79.1048 66.1055 79.1048V72.7832C67.8229 72.7832 69.248 74.2083 69.248 75.9257Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3873 69.2026V82.6862C64.3873 81.8092 64.0585 81.0419 63.4738 80.4572C62.9257 79.9091 62.1218 79.5437 61.2448 79.5437H55.6175C53.6078 79.5437 52 77.9359 52 75.9261C52 74.9395 52.402 74.026 53.0597 73.3683C53.7174 72.7106 54.6309 72.3086 55.6175 72.3086H61.2448C62.9622 72.3086 64.3873 70.9201 64.3873 69.2026Z",
    fill: "#FAFBFC",
    stroke: "#192657",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8457 72.3086V79.361",
    stroke: "#192657",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1055 68.3619V83.2706C66.1055 83.7456 65.7036 84.1476 65.2285 84.1476C64.7535 84.1476 64.3516 83.7456 64.3516 83.2706V68.3619C64.3516 67.8869 64.7535 67.5215 65.2285 67.5215C65.4478 67.5215 65.667 67.6311 65.8497 67.7773C65.9959 67.9234 66.1055 68.1427 66.1055 68.3619Z",
    stroke: "#192657",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0508 68.0694L74.1068 65",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.962 69.4946L70.8926 71.0659",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0508 83.5264L74.1068 86.5958",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.962 82.101L70.8926 80.5298",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8652 75.8159H74.7288",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00000161558,
    y1: 7.98027,
    x2: 76.2922,
    y2: 8.30956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSpeaker);
export default __webpack_public_path__ + "static/media/user-speaker.f3bbaccf445e848cfe7a5b37bc3054e1.svg";
export { ForwardRef as ReactComponent };